// ********************General routes***********************
export const login = "/Security/AuthenticateUser";
export const azureADLogin = "/Security/AzureADAuthenticateUser";
export const forgotPassword = "/Security/ForgotPassword";
export const changePassword = "/Security/CreateAndAssignPassword";
export const getUserData = "/Security/UserDataFromTokenForLocalStorage";

// ********************Subscription plan***********************
export const getSubscriptionPlan = "/SubscriptionPlan/GetSubscriptionPlan";
export const getAllplans = "http://192.168.2.149:9594/license/productPlansDetails?product_code=SS"

// ********************assessmentTypes routes***********************
// For frontend
export const assessmentTypes = "/assessment-types";
export const addAssessmentTypes = "/assessment-types/add";
export const editAssessmentTypes = "/assessment-types/edit";

// For Backend
export const getAllAssessmentTypes = "/AssessmentType/AssessmentTypeGetAll";
export const getByIdAssessmentTypes = "/AssessmentType/GetAssessmentTypeById";
export const updateAssessmentTypes = "/AssessmentType/AssessmentTypeUpdate";
export const insertAssessmentTypes = "/AssessmentType/AssessmentTypeInsert";
export const deleteAssessmentTypes = "/AssessmentType/AssessmentTypeDelete";

// **************** Question Categories ******************
export const questionCategory = "/question-types";
export const addQuestionCategory = "/question-types/add";
export const editQuestionCategory = "/question-types/edit";

// For Backend
export const getAllQuestionCategory =
  "/QuestionCategory/QuestionCategoryGetAll";
export const getByIdQuestionCategory =
  "/QuestionCategory/GetQuestionCategoryById";
export const insertQuestionCategory =
  "/QuestionCategory/QuestionCategoryInsert";
export const updateQuestionCategory =
  "/QuestionCategory/QuestionCategoryUpdate";
export const deleteQuestionCategory =
  "/QuestionCategory/QuestionCategoryDelete";

// **************** Response Types ******************
export const responseTypes = "/response-types";
export const addResponseType = "/response-types/add";
export const editResponseType = "/response-types/edit";

// For Backend
export const getAllResponseTypes = "/ResponseType/ResponseTypeGetAll";
export const getByIdResponseType = "/ResponseType/GetResponseTypeById";
export const insertResponseType = "/ResponseType/ResponseTypeInsert";
export const updateResponseType = "/ResponseType/ResponseTypeUpdate";
export const deleteResponseType = "/ResponseType/ResponseTypeDelete";

// **************** Error Pages ******************
export const unauthorized = "/unauthorized";

// **************** Organization ******************

export const organizations = "/organizations";
export const addOrganization = "/organizations/add";
export const editOrganization = "/organizations/edit";

//For Backend
export const getAllOrganizations = "/Organization/OrganizationGetAll";
export const getByIdOrganization = "/Organization/OrganizationGetById";
export const insertOrganization = "/Organization/OrganizationInsert";
export const updateOrganization = "/Organization/OrganizationUpdate";
export const deleteOrganization = "/Organization/OrganizationDelete";

// **************** Questions ******************
//For Backend
export const getAllQuestions = "/Questions/QuestionsGetAll";
export const insertQuestions = "/Questions/QuestionsInsert";
export const getByIdQuestions = "/Questions/GetQuestionsById";
export const updateQuestions = "/Questions/QuestionsUpdate";
export const deleteQuestions = "/Questions/QuestionsDelete";
export const questionsBulkDelete = "/Questions/QuestionsBulkDelete";
export const surveygetAllQuestions = "/Questions/SurveyQuestionsGetAll";


// ******************** User Template routes***********************

export const templateGetAll = "/SurveyForms/TemplateGetAll";
export const templateInsert = "/SurveyForms/TemplateInsert";
export const getDataByTemplateId = "/SurveyForms/GetDataByTemplateId";

// **************** QuestionResponse ******************
//For Backend
export const insertQuestionResponse =
  "/QuestionResponse/QuestionResponseInsert";
export const updateQuestionResponse =
  "/QuestionResponse/QuestionResponseUpdate";
export const deleteQuestionResponse =
  "/QuestionResponse/QuestionResponseDelete";
export const getAllQuestionResponse =
  "/QuestionResponse/QuestionResponseGetAll";

// **************** QuestionResponseOptions ******************
//For Backend
export const insertQuestionResponseOptions =
  "/QuestionResponseOptions/QuestionResponseOptionsInsert";
export const getAllQuestionResponseOptions =
  "/QuestionResponseOptions/QuestionResponseOptionsGetAll";

// **************** Users ******************

export const users = "/users";
export const adduser = "/users/add";
export const edituser = "/users/edit";

//for Backend
export const getAllUsers = "/User/GetUserList";
export const getUserById = "/User/UserDataGetByUserId";
export const insertUser = "/User/UserInsert";
export const updateUser = "/User/UserUpdate";
export const deleteUser = "/User/UserDelete";

export const getRoleList = "/User/GetRoleList";

// **************** SurveyForms ******************
// For frontend
export const surveyPoll = "/poll"
export const surveyQuiz = "/quiz"
export const surveyForms = "/forms";
export const addSurveyForms = "/forms/add";
export const editSurveyForms = "/forms/edit";

//For Backend
export const getAllSurveyForms = "/SurveyForms/SurveyFormsGetAll";
export const getAllSurveyFormsForTrendReport = "/SurveyForms/SurveyFormsGetAllTrendReport";
export const getAllSurveyFormsForCrossTabReport = "/SurveyForms/SurveyFormsGetAllCrossTab";
export const getUserPivotSettings = "/Dashboard/GetUserPivotSettings";
export const getQuestionTrendReport = "/SurveyForms/QuestionTrendAnalysis";
export const getQuestionCrossTabAnalysis = "/SurveyForms/QuestionCrossTabAnalysis";
export const getAllQuestionForTrendReport = "/SurveyForms/GetAllQuestionBasedOnForm";
export const insertSurveyForm = "/SurveyForms/SurveyFormsInsert";
export const updateSurveyForm = "/SurveyForms/SurveyFormsUpdate";
export const copySurveyForm = "/SurveyForms/SurveyFormCopy";
export const copyQuiz = "/SurveyForms/QuizCopy";
export const deleteSurveyForms = "/SurveyForms/SurveyFormsDelete";
export const getSurveyFormById = "/SurveyForms/GetSurveyFormsById";
export const getSurveysFormsDetails = "/SurveyForms/SurveysFormsDetails";
export const getSurveyFormByIdForPoll = "/SurveyForms/GetSurveyFormsByIdForPoll";
export const deletePoll = "/SurveyForms/PollDelete";
export const insertPoll = "/SurveyForms/PollInsert";
export const updatePoll = "/SurveyForms/PollUpdate";


// **************** SurveySectionQuestions ******************
// For frontend
export const surveySectionQuestionList = "Survey-sections/:id";

//For Backend
export const getAllSurveySectionQuestions =
  "/SurveySectionQuestions/SurveySectionQuestionsGetAll";
export const deleteSurveySectionQuestions =
  "/SurveySectionQuestions/SurveySectionQuestionsDelete";
export const insertSurveySectionsQuestions =
  "/SurveySectionQuestions/SurveySectionQuestionsInsert";
export const updateSurveySectionsQuestions =
  "/SurveySectionQuestions/SurveySectionQuestionsUpdate";
export const getSurveySectionMarks =
  "/SurveySectionQuestions/SurveySectionQuestionBasedOnSection";

// **************** SurveySection ******************
export const SurveySections = "/surveys-sections/:id";

//For Backend
export const getAllSurveySections = "/SurveySections/SurveySectionsGetAll";
export const getSurveySectionsDetails = "/SurveySections/SurveySectionsDetail";
export const insertSurveySections = "/SurveySections/SurveySectionsInsert";
export const updateSurveySections = "/SurveySections/SurveySectionsUpdate";
export const deleteSurveySections = "/SurveySections/SurveySectionsDelete";
export const getSectionById = "/SurveySections/GetSurveySectionsById";

// **************** Survey Assignment ******************
export const surveyAssignment = "/survey-assignment";
export const surveyAssignmentList = "/survey-assignment/list";
export const surveyAssignmentListQuizForm = "/form-assignment";
export const surveyAssignmentListPoll = "/form-assignment/poll";
export const addAssignmentPoll = "/poll-assignment";


//For Backend
export const getAllSurveyAssignments =
  "/SurveyAssignments/SurveyAssignmentsGetAll";
export const getSurveyAssignmentById =
  "/SurveyAssignments/GetSurveyAssignmentsDataById";
export const insertSurveyAssignment =
  "/SurveyAssignments/SurveyAssignmentsInsert";
export const updateSurveyAssignment = "/SurveyAssignments/SurveyAssignmentsUpdate";
export const updateDateSurveyAssignment = "/SurveyAssignments/SurveyAssignmentsDateUpdate";
export const deleteSurveyAssignment =
  "/SurveyAssignments/SurveyAssignmentsDelete";
export const getSurveyFormsById = "/SurveyForms/GetSurveyFormsById";
export const publishSurveys = "/SurveyAssignments/SurveyAssignmentPublish";
export const publishSurveysList = "/SurveyAssignments/SurveyAssignmentPublishList";


// ********************** Common APIS ************************
export const expotExcel = "/Common/ExportExcel";
export const importExcel = "/User/ImportUsersExcel";
export const importQuestionExcel = "/Questions/ImportQuestionExcel";
export const importUserDataExcel = "/SurveyResponses/ImportRandomUserResponseDataExcel";

// **************** Survey Responses ******************
export const getAllSurveyResponses = "/SurveyResponses/SurveyResponsesGetAll";
export const insertSurveyResponse = "/SurveyResponses/SurveyResponsesInsert";
export const insertSurveyResponseViewDateTime = "/SurveyResponses/SurveyResponsesInsertViewDateTime";
export const getPollResponse = "/Surveys/GetPollCountUser";

// **************** Survey Question Branch Logic ******************
export const getAllSurveyBranchLogic =
  "/SurveyQuestionBranchLogic/SurveyQuestionBranchLogicGetAll";
export const addSurveyBranchLogic =
  "/SurveyQuestionBranchLogic/SurveyQuestionBranchLogicInsert";
export const deleteSurveyBranchLogic =
  "/SurveyQuestionBranchLogic/SurveyQuestionBranchLogicDelete";
export const getBranchLogicByQuestionId =
  "/SurveyForms/BranchLogicGetByQuestionId";

// **************** Surveys ******************
export const getSurveysCount = "/Surveys/GetSurveysCount";
export const getSurveysCountTotal = "/Surveys/GetSurveysCountTotal";
export const getSurveyById = "/Surveys/GetSurveysById";
export const getAllSurveys = "/Surveys/SurveysGetAll";
export const surveyQuizIsViewUpdate = "/SurveyResponses/SurveyQuizIsViewUpdate";
export const resetSurveyDetailsGetAll = "/Surveys/ResetSurveyDetailsGetAll";
export const emailLogDetails = "/Surveys/GetEmailLogCountForSurvey";

// ******************* Dashboard **********************

//For Backend
export const getDashboardStatisticsCount =
  "/Dashboard/GetDashboardStatisticsCount";
export const getEmployeeEngagementDetailsBySurvey =
  "/Dashboard/GetEmployeeEngagementDetailsBySurvey";
export const getFormResponseAnalysis = "/Dashboard/GetFormResponseAnalysis";
export const getDashboardStatisticsCountForAdmin =
  "/Dashboard/GetDashboardLatestAdmin";

// ******************* User Dashboard **********************

//For Backend
export const getUserDashboardStatisticsCount =
  "/Dashboard/GetUserFormsStatus";
  export const GetFormDetailsByUserId =
  "/Dashboard/GetSurveyDetailsByUserId";


// ******************* Encrypt and Decrypt **********************
export const encryptedText = "/Common/Encrypt";
export const decryptedText = "/Common/Decrypt";

// **************** User Department ******************
export const userDepartment = "/user-department";

//For Backend
export const getAllUserDepartments = "/UserDepartment/UserDepartmentGetAll";
export const deleteUserDepartment = "/UserDepartment/UserDepartmentDelete";
export const insertUserDepartment = "/UserDepartment/UserDepartmentInsert";
export const getUserDepartmentById = "/UserDepartment/GetUserDepartmentById";
export const updateUserDepartment = "/UserDepartment/UserDepartmentUpdate";

// **************** User Classification ******************
export const userClassification = "/user-classification";

//For Backend
export const getAllUserClassifications =
  "/UserClassification/UserClassificationGetAll";
export const deleteUserClassification =
  "/UserClassification/UserClassificationDelete";
export const getUserClassificationById =
  "/UserClassification/GetUserClassificationById";
export const insertUserClassification =
  "/UserClassification/UserClassificationInsert";
export const updateUserClassification =
  "/UserClassification/UserClassificationUpdate";

// **************** Location ******************
export const locationMaster = "/location";

//For Backend
export const getAllLocations = "/Location/LocationGetAll";
export const deleteLocation = "/Location/LocationDelete";
export const getLocationById = "/Location/GetLocationById";
export const insertLocation = "/Location/LocationInsert";
export const updateLocation = "/Location/LocationUpdate";

// **************** User Designation ******************
export const userDesignation = "/user-designation";

//For Backend
export const deleteUserDesignation = "/UserDesignation/UserDesignationDelete";
export const getAllUserDesignations = "/UserDesignation/UserDesignationGetAll";
export const getUserDesignationById = "/UserDesignation/GetUserDesignationById";
export const insertUserDesignation = "/UserDesignation/UserDesignationInsert";
export const updateUserDesignation = "/UserDesignation/UserDesignationUpdate";

// **************** Tempelate ******************
export const tempelateMaster = "/tempelate";
export const addTempelate = "/tempelate/add";
export const editTempelate = "/tempelate/edit";

//For Backend
export const getAllTemplates = "/Tempelate/TempelateGetAll";
export const deleteTemplate = "/Tempelate/TempelateDelete";
export const getTemplateById = "/Tempelate/GetTempelateById";
export const insertTemplate = "/Tempelate/TempelateInsert";
export const updateTemplate = "/Tempelate/TempelateUpdate";



// **************** Reports ******************
//For Frontend
export const responseAnalysisReport = "/response-analysis-report";
export const comparisonReport = "/comparison-report";
export const trendReport = "/trend-report";
export const SentimentAnalyticsReport = "/SentimentAnalyticsReport";
export const SurveyAssignedUsersResponses = "/SurveyAssignedUsersResponses";
export const FormReport = "/form-report";
export const QuestionBankAnalysisReport = "/QuestionBankAnalysisReport";
export const crossTabReport = "/cross-tab-report"


//For Backend
export const getSurveyAssignmentsWithoutPublic = "/Dashboard/GetSurveyAssignmentsWithoutPublic";
export const getTrackingFormReport = "/Dashboard/GetFormResponseAnalysis";
export const getTrendFormReport = "/Dashboard/GetTrendAnalysisReport";
export const getGetSentimentAnalyticsReport = "/Dashboard/GetSentimentAnalyticsReport";
export const comparisonReportAPI = "/Dashboard/GetDashboardStatisticsForCompare";
export const getCrossTabAnalysisReport = "/Dashboard/GetCrossTabAnalysisReport";
export const getCrossTabAnalysisReportLatest = "/Dashboard/GetCrossTabAnalysisReportLatest";
export const upsertUserPivotSettings = "/Dashboard/UpsertUserPivotSettings";

// **************** MatrixResponse ******************
//For Backend
export const insertMatrixResponse = "/MatrixFields/MatrixFieldsInsert";
export const getAllMatrixResponses = "/MatrixFields/MatrixFieldsGetAll";


// **************** Configurations ******************
//For Backend
export const getAllConfiguration = "/Configuration/ConfigurationGetAll";

// **************** ConfigurationDetail ******************
//For Backend
export const getAllConfigurationDetail = "/ConfigurationDetail/ConfigurationDetailGetAll";
export const ConfigurationDetailInsert = "/ConfigurationDetail/ConfigurationDetailInsert";

// **************** SignUp ******************

//For Backend
export const organizationInsertForSignUp = "/Organization/OrganizationInsertSingleSignUp";
